// extracted by mini-css-extract-plugin
export default {"content":"PerformanceSummary_content__5qjEK"};